import { EventListenerFocusTrapInertStrategy } from '@angular/cdk/a11y';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'jump-to-top',
    templateUrl: './jump-to-top.component.html',
    styleUrls: ['./jump-to-top.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JumpToTopComponent {
  public show: boolean = false;
  @Output('scrollTriggered') scrollTriggered = new EventEmitter<string>();
  handleScroll(event: Event) {
    let scroll = (event.target as HTMLElement).scrollTop;
    let triggerHeight = window.innerHeight;
    if (this.show && scroll < triggerHeight) {
      this.show = false;
    } else if (!this.show && scroll > triggerHeight) {
      this.show = true;
    }
  }

  jumpToTop() {
    this.scrollTriggered.next('top');
  }
}
